var React = require('react');

function UiRound (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("path",{"stroke":"#FFF","strokeWidth":"2","d":"M82.5 60l-45 22.5v-45z"})));
}

UiRound.defaultProps = {"width":"120","height":"120","viewBox":"0 0 120 120"};

module.exports = UiRound;

UiRound.default = UiRound;
